(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[604],{

/***/ 22622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ DefaultHeader; }
});

// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-hooks-virtual-3f1c509501/1/mp-library/packages/hooks/dist/index.js
var dist = __webpack_require__(50686);
// EXTERNAL MODULE: ../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(45721);
// EXTERNAL MODULE: ./src/shared/context/user/index.ts
var user = __webpack_require__(87275);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/utils.tsx
var utils = __webpack_require__(3521);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-simple-dropdown-virtual-9db7fc1e8c/1/mp-library/packages/components/simple-dropdown/dist/index.js
var simple_dropdown_dist = __webpack_require__(731);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/utils.ts
var getIndividualAndBusinessCategories = function getIndividualAndBusinessCategories(headerData) {
  return headerData.filter(function (headerCategory) {
    return headerCategory.categoryId === 'individual' || headerCategory.categoryId === 'business';
  });
};
var geHeaderCategory = function geHeaderCategory(headerData, category) {
  return headerData.find(function (headerCategory) {
    return headerCategory.categoryId === category;
  });
};
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-button-virtual-fb136682cc/1/mp-library/packages/components/button/dist/index.js
var button_dist = __webpack_require__(9084);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-typography-virtual-3da32b9aec/1/mp-library/packages/components/typography/dist/index.js
var typography_dist = __webpack_require__(85265);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 3 modules
var shared_utils = __webpack_require__(40117);
// EXTERNAL MODULE: ../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(86521);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/category-dropwdown/category-dropdown-content.tsx





var CategoryDropDownContent = function CategoryDropDownContent(_ref) {
  var categoryList = _ref.categoryList,
      categoryL2Setter = _ref.categoryL2Setter,
      categroyL3Setter = _ref.categroyL3Setter,
      level = _ref.level;
  var borderClasses = 'border-b-sm border-dashed border-b-grey-300';

  var hoverHanlder = function hoverHanlder(category, levelSelected) {
    if (typeof categoryL2Setter === 'function') categoryL2Setter(category.subMenu);
    var categoryL3Category = levelSelected === 'L1' ? category.subMenu[0] : category;
    if (typeof categroyL3Setter === 'function') categroyL3Setter(categoryL3Category);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: categoryList.length ? categoryList.map(function (category, idx, categoryArr) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hover:bg-brand-200",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(typography_dist.Text, {
          onClick: function onClick() {
            (0,shared_utils/* trackAction */.X2)('click', '', {
              label: "top_nav_menu_item_".concat(category.seoSlug)
            });
          },
          type: "a",
          href: "/services/".concat(category.seoSlug, "/c"),
          mergeClasses: "override",
          onMouseOver: function onMouseOver() {
            return hoverHanlder(category, level);
          },
          className: "text-brand-1000 mx-2 cursor-pointer flex justify-between items-center text-s-14 font-medium py-3 pl-6 ".concat(idx + 1 === categoryArr.length ? '' : borderClasses),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
            textSize: "sm",
            weight: "medium",
            children: category.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "font-bold icon-right-arrow text-grey-800 mr-2 flex align-middle text-s-10"
          })]
        })
      }, category.categoryId);
    }) : null
  });
};
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/category-dropwdown/index.module.css
var index_module = __webpack_require__(86050);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/category-dropwdown/index.tsx









/**
 * We have 3 columns, THeaderCategory is of recursive type
 * where each category can have a list of subcategories.
 * Section 1 & 2 are lists of categories, where as section 3 is
 * the final selected category.
 *
 * categoryData --(children)-> categoryL1 --(children)-> categoryL2 -> SelectedL2Catgory
 *
 * @param - `categoryData` - The root category *
 * @param - `className` - classnames
 *
 */
var CategoryDropDown = function CategoryDropDown(_ref) {
  var categoryData = _ref.categoryData,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var categoryL1 = categoryData ? categoryData.subMenu : [];

  var _useState = (0,react.useState)([]),
      categoryL2 = _useState[0],
      setCategoryL2 = _useState[1];

  var _useState2 = (0,react.useState)(),
      categoryL3 = _useState2[0],
      setCategoryL3 = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat(className),
    role: "menu",
    "aria-orientation": "vertical",
    "aria-labelledby": "menu-button",
    tabIndex: -1,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex w-full bg-white pb-6 rounded-b-lg",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).categoryContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryDropDownContent, {
          categoryList: categoryL1,
          categoryL2Setter: setCategoryL2,
          categroyL3Setter: setCategoryL3,
          level: "L1"
        })
      }), categoryL2.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).categoryContainer, " bg-white border-l-sm border-l-grey-300"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryDropDownContent, {
          categoryList: categoryL2,
          categroyL3Setter: setCategoryL3,
          level: "L2"
        })
      }) : null, categoryL3 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "px-2 ".concat((index_module_default()).categoryContainer),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          weight: "bold",
          textSize: "base",
          type: "p",
          className: "text-brand-1000 pt-3",
          children: categoryL3.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          weight: "medium",
          textSize: "sm",
          type: "p",
          className: "text-grey-600 mb-6 pt-5",
          children: categoryL3.description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          type: "a",
          href: "/services/".concat(categoryL3.seoSlug, "/c"),
          onClick: function onClick() {
            (0,shared_utils/* trackAction */.X2)('click', '', {
              label: "top_nav_menu_item_".concat(categoryL3.seoSlug)
            });
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
            rounded: "md",
            variant: "hollowBlue",
            children: 'View products'
          })
        })]
      }) : null]
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/category-dropwdown/category-dropdown-desktop-button.tsx




var CategoryNavbarButtonDesktop = function CategoryNavbarButtonDesktop(_ref) {
  var category = _ref.category,
      headerData = _ref.headerData,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'text-brand-1000 pl-8' : _ref$className,
      _ref$dropdownClassNam = _ref.dropdownClassName,
      dropdownClassName = _ref$dropdownClassNam === void 0 ? 'origin-top-right absolute sm:relative left-5 mt-2 rounded-lg shadow-md sm:shadow-none focus:outline-none' : _ref$dropdownClassNam;
  var dropdownText = category === 'individual' ? 'Individuals' : 'Businesses';
  var categoryToRender = geHeaderCategory(headerData, category);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(simple_dropdown_dist.SimpleDropdown, {
    dropDownText: dropdownText,
    dropdownContent: categoryToRender ? /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryDropDown, {
      categoryData: categoryToRender,
      className: dropdownClassName
    }) : null,
    className: className
  });
};
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/header.api.tsx
var header_api = __webpack_require__(65712);
// EXTERNAL MODULE: ../.yarn/__virtual__/next-virtual-982f7924cf/0/cache/next-npm-12.2.5-8247fb1613-e8fcbd93d7.zip/node_modules/next/router.js
var next_router = __webpack_require__(43001);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/my-account-dropdown/index.tsx
var my_account_dropdown = __webpack_require__(15782);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/logged-in-out/index.tsx
/* provided dependency */ var Buffer = __webpack_require__(32777)["Buffer"];









var LoggedOutSection = function LoggedOutSection() {
  var router = (0,next_router.useRouter)();
  var returnPath = Buffer.from(router.asPath).toString('base64');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      className: "text-brand-1000 pr-6",
      type: "a",
      href: "https://www.clear.in/s/contact-us",
      onClick: function onClick() {
        return (0,shared_utils/* trackAction */.X2)('click', '', {
          label: 'top_nav_menu_Support'
        });
      },
      children: "Support"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      type: "a",
      href: "".concat("https://accounts.cleartax.in/v2?product=cleartax", "&return_path=").concat(returnPath),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
        variant: "blue",
        rounded: 'lg',
        className: "text-brand-1000 bg-brand-200 border-none",
        onClick: function onClick() {
          return (0,shared_utils/* trackAction */.X2)('click', '', {
            label: 'top_nav_menu_Login/Register'
          });
        },
        children: "Login/Register"
      })
    })]
  });
};
var LoggedInSection = function LoggedInSection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      className: "text-brand-1000 pr-6 whitespace-nowrap",
      type: "a",
      href: "/services/my_orders",
      onClick: function onClick() {
        return (0,shared_utils/* trackAction */.X2)('click', '', {
          label: 'top_nav_menu_My Orders'
        });
      },
      children: "My Orders"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(simple_dropdown_dist.SimpleDropdown, {
      dropDownText: "My Account",
      dropdownContent: /*#__PURE__*/(0,jsx_runtime.jsx)(my_account_dropdown/* MyAccountDropdown */.Q, {}),
      className: "text-brand-1000 whitespace-nowrap"
    })]
  });
};
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-drawer-virtual-1694e749cc/1/mp-library/packages/components/drawer/dist/index.js
var drawer_dist = __webpack_require__(21502);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-icons-virtual-6f15865340/1/mp-library/packages/components/icons/dist/index.js
var icons_dist = __webpack_require__(14384);
// EXTERNAL MODULE: ./src/shared/icons/index.ts + 1 modules
var icons = __webpack_require__(97992);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-select-virtual-711d9177b6/1/mp-library/packages/components/select/dist/index.js
var select_dist = __webpack_require__(33107);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(25060);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/utils.ts

var findSearchDocumentWithName = function findSearchDocumentWithName(searchItems, name) {
  var _searchItems$hits;

  return searchItems === null || searchItems === void 0 ? void 0 : (_searchItems$hits = searchItems.hits) === null || _searchItems$hits === void 0 ? void 0 : _searchItems$hits.find(function (el) {
    return el.document.name === name;
  });
};
var getOptionsForSelect = function getOptionsForSelect(searchItems) {
  var _searchItems$hits2;

  if (!searchItems) return [];
  return (_searchItems$hits2 = searchItems.hits) === null || _searchItems$hits2 === void 0 ? void 0 : _searchItems$hits2.map(function (_ref) {
    var document = _ref.document;
    return {
      value: document.seo_slug,
      label: document.name
    };
  }).slice(0, constants/* SEARCH_RESULTS_TO_SHOW */.OQ);
};
// EXTERNAL MODULE: ../.yarn/__virtual__/react-sanitized-html-virtual-1ca2f5dc21/0/cache/react-sanitized-html-npm-2.0.0-e2d414a5f8-8611759fb4.zip/node_modules/react-sanitized-html/lib/index.js
var lib = __webpack_require__(67068);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/search/custom-search-result/sanitize.module.css
var sanitize_module = __webpack_require__(42195);
var sanitize_module_default = /*#__PURE__*/__webpack_require__.n(sanitize_module);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/custom-search-result/desktop.tsx




var DekstopCustomSearchResult = function DekstopCustomSearchResult(_ref) {
  var searchItem = _ref.searchItem,
      seachHighlights = _ref.seachHighlights;
  var nameHighlight = seachHighlights.find(function (highlight) {
    return highlight.field === 'name';
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
    type: "a",
    mergeClasses: "override",
    href: "/services/".concat(searchItem.seo_slug, "/p"),
    className: "".concat((sanitize_module_default()).customMark, " cursor-pointer p-3 w-full block font-medium text-grey-600 hover:bg-brand-200 sm:font-normal sm:text-brand-1000 sm:text-base sm:hover:bg-white sm:overflow-hidden sm:max-w-[100vw] sm:p-5"),
    children: nameHighlight ? /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
      className: 'sm:overflow-ellipsis sm:whitespace-nowrap sm:overflow-hidden sm:max-w-full',
      html: nameHighlight.snippet
    }) : searchItem.name
  });
};
// EXTERNAL MODULE: ./src/shared/utils/utils/redirectionOverlay.tsx
var redirectionOverlay = __webpack_require__(88849);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/custom-search-result/mobile.tsx





var MobileCustomSearchResult = function MobileCustomSearchResult(_ref) {
  var searchItem = _ref.searchItem,
      seachHighlights = _ref.seachHighlights;
  var nameHighlight = seachHighlights.find(function (highlight) {
    return highlight.field === 'name';
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
    mergeClasses: "override",
    type: "a",
    href: "/services/".concat(searchItem.seo_slug, "/p"),
    className: "".concat((sanitize_module_default()).customMark, " cursor-pointer p-4 block w-full font-normal text-brand-1000 sm:text-base"),
    onClick: function onClick() {
      return (0,redirectionOverlay/* triggerRedirectionOverLay */.S)(false);
    },
    children: nameHighlight ? /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
      className: 'sm:overflow-ellipsis sm:whitespace-nowrap sm:overflow-hidden sm:max-w-full',
      html: nameHighlight.snippet
    }) : searchItem.name
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/custom-search-result/index.tsx







var CustomSearchResult = function CustomSearchResult(_ref) {
  var searchItems = _ref.searchItems,
      name = _ref.name;
  //TODO: Currently this find is O(n) and we loop over search items so our complexity is O(n^2)
  // Need to optimise, we can allow for now as array length is 10 so hence it will be O(1)
  var currentOption = findSearchDocumentWithName(searchItems, name);
  var isMobile = (0,dist.useIsMobile)();
  if (!currentOption) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    onClick: function onClick() {
      return (0,shared_utils/* trackAction */.X2)('click', '', {
        label: "search_result_".concat(currentOption.document.seo_slug)
      });
    },
    children: isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(MobileCustomSearchResult, {
      searchItem: currentOption.document,
      seachHighlights: currentOption.highlights
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DekstopCustomSearchResult, {
      searchItem: currentOption.document,
      seachHighlights: currentOption.highlights
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/list-suffix/index.tsx





var ListSuffix = function ListSuffix(_ref) {
  var searchInputValue = _ref.searchInputValue,
      _ref$noResults = _ref.noResults,
      noResults = _ref$noResults === void 0 ? false : _ref$noResults;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [noResults ? /*#__PURE__*/(0,jsx_runtime.jsxs)(typography_dist.Text, {
      mergeClasses: "override",
      className: "w-full h-32 p-10 flex items-center justify-center font-medium text-grey-600 text-s-12 border-grey-300 border-x border-b sm:border-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        type: "span",
        className: "icon-info mr-2 mt-1 text-grey-600 block w-1/12"
      }), "Currently there are no search results available for this query, please click below to see more."]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(typography_dist.Text, {
      type: "a",
      mergeClasses: "override",
      href: "/services/search/".concat(searchInputValue),
      onClick: function onClick() {
        (0,shared_utils/* trackAction */.X2)('click', '', {
          label: "search_see_more_".concat(searchInputValue)
        });
      },
      className: "py-3 font-bold cursor-pointer text-center block w-full text-brand-700 border-t-0 border-sm border-grey-300 rounded-b-lg sm:text-base sm:border-0",
      children: ["See more", /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        type: "span",
        weight: "medium",
        className: "icon-arrow_back rotate-180 inline-block pb-0.5 pr-2"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/search-open-close/index.tsx


var SearchOpenClose = function SearchOpenClose(_ref) {
  var open = _ref.open,
      closeCB = _ref.closeCB;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "h-full cursor-pointer flex items-center text-grey-400 font-medium pt-1",
    children: open ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: function onClick() {
        return closeCB ? closeCB() : null;
      },
      className: "icon-arrow_back text-grey-500 text-s-20 font-semibold"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist.SearchIcon, {
      className: "ml-2"
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/search/index.component.tsx










var Search = function Search(_ref) {
  var open = _ref.open,
      closeCB = _ref.closeCB;

  var _useState = (0,react.useState)(''),
      searchInputValue = _useState[0],
      setSearchInputValue = _useState[1];

  var _useState2 = (0,react.useState)(),
      searchItems = _useState2[0],
      setSearchItems = _useState2[1];

  var searchQuery = (0,dist.useDebounce)(searchInputValue, 300);

  var _useApi = (0,dist.useApi)({}, header_api/* searchApi */.Ue, true),
      getSearchResults = _useApi.request,
      searchResults = _useApi.data,
      isSearchResultsLoading = _useApi.isLoading;

  (0,react.useEffect)(function () {
    if (searchQuery !== '') getSearchResults(searchQuery);else setSearchItems(undefined);
  }, [searchQuery]);
  (0,react.useEffect)(function () {
    if (isSearchResultsLoading === false) setSearchItems(searchResults);
  }, [isSearchResultsLoading]);

  var _onEnterCB = function onEnterCB(option) {
    if (option.value) {
      window.location.href = "/services/".concat(option.value, "/p");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex mx-10 w-full relative justify-between sm:mx-0 sm:static sm:w-full sm:h-full",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(select_dist.SelectContainer, {
      options: getOptionsForSelect(searchItems),
      id: 'search-container',
      onChange: function onChange(value) {
        return setSearchInputValue(value);
      },
      onBlur: function onBlur(value) {
        return setSearchInputValue(value);
      },
      value: searchInputValue,
      disableOptionFiltering: true,
      className: 'w-full mb-1 sm:w-full sm:h-full',
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:px-4 sm:sticky sm:top-0 sm:w-full sm:z-10 sm:pt-4 bg-white",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(select_dist.SelectInput, {
          inputPrefix: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchOpenClose, {
            open: open,
            closeCB: closeCB
          }),
          className: "w-full pl-10 overflow-ellipsis sm:h-10",
          placeholder: 'Search for services & plans related to ITR, GST...',
          autoComplete: 'off'
        })
      }), searchInputValue ? /*#__PURE__*/(0,jsx_runtime.jsx)(select_dist.SelectOptions, {
        overrideListClasses: {
          containerClasses: 'rounded-b-lg absolute z-50 bg-white w-full sm:z-0 sm:h-full sm:rounded-0 sm:relative',
          elementClasses: 'border border-t-0 break-all border-grey-300 sm:border-l-0 sm:border-r-0 sm:border-dashed sm:max-w-[100vw]',
          lastChildClasses: 'rounded-b-0'
        },
        renderCustomElement: function renderCustomElement(option) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CustomSearchResult, {
            searchItems: searchItems,
            name: option.label
          });
        },
        onEnterCB: function onEnterCB(option) {
          return _onEnterCB(option);
        },
        listSuffix: searchItems && searchItems.found ? /*#__PURE__*/(0,jsx_runtime.jsx)(ListSuffix, {
          searchInputValue: searchInputValue
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ListSuffix, {
          searchInputValue: searchInputValue,
          noResults: true
        })
      }) : null]
    })
  });
};
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/hamburger-sidebar/index.tsx + 1 modules
var hamburger_sidebar = __webpack_require__(51143);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/hamburger-sidebar/sidebar-dropdown.tsx
var sidebar_dropdown = __webpack_require__(73159);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/nav-sidebar/index.tsx




var NavSidebar = function NavSidebar(_ref) {
  var open = _ref.open,
      closeCB = _ref.closeCB,
      categorySelected = _ref.categorySelected,
      headerData = _ref.headerData;
  var categoryToShow = geHeaderCategory(headerData, categorySelected);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(drawer_dist.Drawer, {
    onCloseCallBack: function onCloseCallBack() {
      return closeCB();
    },
    isOpen: open,
    direction: 'right',
    width: '4/5',
    minWidth: 300,
    animationDuration: 500,
    top: '80px',
    hideIcon: true,
    closeOnClickOverlay: true,
    children: categoryToShow ? categoryToShow.subMenu.map(function (category) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(sidebar_dropdown/* SidebarDropDown */.J, {
        headerClasses: 'text-s-14 text-brand-1000 mb-4 font-medium',
        contentArr: category.subMenu.map(function (subCategory) {
          return {
            name: subCategory.name,
            href: "/services/".concat(subCategory.seoSlug, "/c")
          };
        }),
        contentHeader: category.name
      }, category.categoryId);
    }) : null
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/utils.tsx



var CategoryNavbarButton = function CategoryNavbarButton(_ref) {
  var selectedCategory = _ref.selectedCategory,
      toggleSidebar = _ref.toggleSidebar,
      category = _ref.category;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(button_dist.Button, {
    mergeClasses: "override",
    onClick: function onClick() {
      return toggleSidebar(category);
    },
    className: "text-s-14 text-brand-1000 font-medium  cursor-pointer",
    children: [category === 'individual' ? 'Individuals' : 'Businesses', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(selectedCategory === category ? '' : 'rotate-180', " icon-up-arrow1 px-2 text-base inline-block pb-0.5")
    })]
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/index.tsx














var CloseIcon = function CloseIcon(_ref) {
  var _ref$backIcon = _ref.backIcon,
      backIcon = _ref$backIcon === void 0 ? false : _ref$backIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mt-1.5",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(backIcon ? 'icon-arrow_back' : 'icon-clear', " text-brand-1000 text-s-20 font-semibold")
    })
  });
};

var MobileHeader = function MobileHeader(_ref2) {
  var headerData = _ref2.headerData;

  var _useState = (0,react.useState)(false),
      mobileSidebarOpen = _useState[0],
      setMobileSidebarOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      mobileSearchOpen = _useState2[0],
      setMobileSearchOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      navSidebarOpen = _useState3[0],
      setNavSidebarOpen = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      selectedCategory = _useState4[0],
      setSelectedCategory = _useState4[1];

  var _toggleSidebar = function toggleSidebar(category) {
    setSelectedCategory(function (prevCategory) {
      if (prevCategory !== category) {
        setNavSidebarOpen(true);
        return category;
      } else {
        setNavSidebarOpen(false);
        return '';
      }
    });
  };

  var handleCloseNavSidebar = function handleCloseNavSidebar() {
    setSelectedCategory('');
    setNavSidebarOpen(false);
  };

  var commonCloseIconHandler = function commonCloseIconHandler() {
    if (selectedCategory === '') setMobileSidebarOpen(function (prevState) {
      return !prevState;
    });else handleCloseNavSidebar();
  };

  var handleCloseSearch = function handleCloseSearch() {
    return setMobileSearchOpen(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wg-container h-full items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center h-12 sm:justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(utils/* HeaderLogo */.O, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
            mergeClasses: "override",
            className: "cursor-pointer",
            onClick: function onClick() {
              setMobileSearchOpen(true);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist.SearchIcon, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "cursor-pointer pl-2 w-8",
            onClick: function onClick() {
              return commonCloseIconHandler();
            },
            children: mobileSidebarOpen || navSidebarOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* HamburgerIcon */.U, {})
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(drawer_dist.Drawer, {
        onCloseCallBack: function onCloseCallBack() {
          return setMobileSearchOpen(false);
        },
        isOpen: mobileSearchOpen,
        direction: 'right',
        width: 'full',
        minWidth: 300,
        animationDuration: 300,
        hideIcon: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full flex items-start h-full overflow-hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Search, {
            open: mobileSearchOpen,
            closeCB: handleCloseSearch
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavSidebar, {
        open: navSidebarOpen,
        closeCB: handleCloseNavSidebar,
        headerData: headerData,
        categorySelected: selectedCategory
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(hamburger_sidebar/* HamburgerSidebar */.z, {
        open: mobileSidebarOpen,
        closeCB: setMobileSidebarOpen
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "wg-container flex items-center h-8 bg-white w-full",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CategoryNavbarButton, {
          category: 'individual',
          selectedCategory: selectedCategory,
          toggleSidebar: function toggleSidebar() {
            return _toggleSidebar('individual');
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryNavbarButton, {
          category: 'business',
          selectedCategory: selectedCategory,
          toggleSidebar: function toggleSidebar() {
            return _toggleSidebar('business');
          }
        })]
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/header.tsx












var DefaultHeader = function DefaultHeader() {
  var _useApi = (0,dist.useApi)([], header_api/* getHeaderDetails */.O5, true),
      getHeaderData = _useApi.request,
      headerData = _useApi.data;

  var isMobile = (0,dist.useIsMobile)();
  var isDomLoaded = (0,dist.useDomLoaded)();
  var userContext = (0,user/* useUserCtx */.X)();
  (0,react.useEffect)(function () {
    getHeaderData();
  }, []);
  if (!isDomLoaded) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
    className: "w-full h-20 sticky top-0 bg-white z-50 sm:h-12",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wg-container flex h-full items-center sm:justify-between sm:hidden",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(utils/* HeaderLogo */.O, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-full justify-between items-center sm:hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CategoryNavbarButtonDesktop, {
            category: "individual",
            headerData: headerData
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryNavbarButtonDesktop, {
            category: "business",
            headerData: headerData,
            className: 'text-brand-1000',
            dropdownClassName: 'origin-top-right absolute sm:relative -left-32 mt-2 rounded-lg shadow-md sm:shadow-none focus:outline-none'
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Search, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex items-center",
          children: userContext.isLoggenIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedInSection, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedOutSection, {})
        })]
      })]
    }), isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(MobileHeader, {
      headerData: headerData
    }) : null]
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/index.tsx


/***/ }),

/***/ 3521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ HeaderLogo; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85265);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25060);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86521);



var HeaderLogo = function HeaderLogo(_ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .MARKETPLACE_PATH */ .Bd : _ref$href;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_0__.Text, {
    type: "a",
    className: "cursor-pointer",
    href: href,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
      src: "https://assets1.cleartax-cdn.com/cleartax/images/1665038118_clearlogo1.svg",
      alt: "CT logo",
      className: "sm:w-28",
      width: 153
    })
  });
};

/***/ }),

/***/ 88849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ wrapperRedirectionOverlay; },
/* harmony export */   "S": function() { return /* binding */ triggerRedirectionOverLay; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_overlay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84266);
/* harmony import */ var _cleartax_wg_library_overlay__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_overlay__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32221);
/* harmony import */ var _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43687);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25060);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76442);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86521);





/**
 * Renders a redirection overlay component in #redirection-overlay
 *
 * @returns void
 */


var triggerRedirectionOverLay = function triggerRedirectionOverLay() {
  var toaster = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  react_dom__WEBPACK_IMPORTED_MODULE_2__.render( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_cleartax_wg_library_overlay__WEBPACK_IMPORTED_MODULE_0__.Overlay, {
    classNames: "z-1000",
    isOverlay: true,
    onClick: function onClick() {},
    children: (0,___WEBPACK_IMPORTED_MODULE_4__/* .getPageLoader */ .$S)()
  }), document.getElementById(_config_constants__WEBPACK_IMPORTED_MODULE_3__/* .REDIRECTION_OVERLAY_ID */ .R5));
  if (toaster) _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_1__.Toster.Loader('Redirecting....');
};
var wrapperRedirectionOverlay = function wrapperRedirectionOverlay(url, iterval) {
  triggerRedirectionOverLay();

  if (window !== undefined && url) {
    setTimeout(function () {
      window.location.href = url;
    }, iterval);
  }
};

/***/ }),

/***/ 86050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryContainer":"category-dropwdown_categoryContainer__EtnoN"};

/***/ }),

/***/ 42195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customMark":"sanitize_customMark__lVcw6","customMarkMobile":"sanitize_customMarkMobile__3GzLJ"};

/***/ }),

/***/ 89872:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 81110:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59154:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 49548:
/***/ (function() {

/* (ignored) */

/***/ })

}]);